import apiInstance from './vouchersApiClient'
import type { Voucher } from '#src/interfaces/voucher'
import type { VoucherConfiguration } from '#src/interfaces/voucherConfiguration'
import type { VoucherSearchParams } from '#src/interfaces/voucherSearchParams'
import type { VoucherSearchResponse } from '#src/interfaces/voucherSearchResponse'

const getVoucherById = async (tenantId: string, voucherId: string) =>
  apiInstance.get<Voucher>(`/tenants/${tenantId}/vouchers/${voucherId}`)

const getVoucherByBarcode = async (tenantId: string, barcode: string) =>
  apiInstance.get<Voucher>(`/tenants/${tenantId}/vouchers/barcode/${barcode}`)

const issueVoucher = async (tenantId: string, value: number, currency: string) =>
  apiInstance.post<Voucher>(`/tenants/${tenantId}/vouchers`, {
    value,
    currency
  })

const redeemVoucher = async (tenantId: string, voucherId: string, providedPin: string) =>
  apiInstance.post(`/tenants/${tenantId}/vouchers/${voucherId}/actions/redeem`, {
    providedPin
  })

const revokeVoucher = async (tenantId: string, voucherId: string, providedPin: string) =>
  apiInstance.post(`/tenants/${tenantId}/vouchers/${voucherId}/actions/revoke`, {
    providedPin
  })

const getVoucherConfig = async (tenantId: string) =>
  apiInstance.get<VoucherConfiguration>(`/tenants/${tenantId}/configurations`)

const searchVouchers = async (tenantId: string, params: VoucherSearchParams) =>
  apiInstance.get<VoucherSearchResponse>(`/tenants/${tenantId}/vouchers`, {
    params
  })

export {
  getVoucherById,
  getVoucherByBarcode,
  issueVoucher,
  redeemVoucher,
  revokeVoucher,
  getVoucherConfig,
  searchVouchers
}
